// extracted by mini-css-extract-plugin
export default {"albums":"FamilyContentPage__albums--CC_nI","extraBlock":"FamilyContentPage__extraBlock--2B767","folders":"FamilyContentPage__folders--1Z7JM"};